import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Chat from "../components/common/Chat";
import Toolbar from "../navigation/Toobar";
import Header from "../layout/Header";
import Splash from "../components/common/Splash";

function Deposit({ items, promotions, userData , transactionData, hasEWallet, usdtRate}){
  const [activeItem, setActiveItem] = useState(null);
	const [activeAmount, setActiveAmount] = useState("");
	const [selectedPromotion, setSelectedPromotion] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const [paymentMethod, setPaymentMethod] = useState(null);
	const [paymentSystems, setPaymentSystems] = useState([]);
	const [submitLoading, setSubmitLoading] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const [modalMessage, setModalMessage] = useState("");
	const token = localStorage.getItem("token");
	const amounts = ["2000", "3000", "5000", "10000", "15000", "20000", "25000", "1000", "500", "200"];
	const [selectedOption, setSelectedOption] = useState(null);
	const [pgs, setPgs] = useState([]);
	const navigate = useNavigate();
	
	const [getotherContracts, setotherContracts] = useState([]);
	const [amountRange, setAmountRange] = useState([100, 25000]);
	const [currency, setCurrency] = useState("৳");
	const [presetAmounts, setPresetAmounts] = useState(["200",  "500", "1000", "2000", "3000", "5000", "10000", "15000", "20000", "25000"]);
	const [depositChannel, setDepositChannel] = useState(false);

	const fetchOther = async () => {
        const token = localStorage.getItem('token');
        if (token) {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/get/other/phone`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                });

                if (response.ok) {
                    const data = await response.json();
                    setotherContracts(data.data || []);
                    console.log(data.data);
                   
                } else {
                    console.error('Failed to fetch user data');
                }
            } catch (error) {
                console.error('Error fetching user data:', error);
            }
        }
    };
	
	useEffect(() => { 
		fetchOther();
		let uniquePaymentMethods = [];
		const seenNames = new Set();

		if (items && items.length > 0) {
			items.forEach((item) => {
				if (item.name && !seenNames.has(item.name.toLowerCase())) {
					seenNames.add(item.name.toLowerCase());
					uniquePaymentMethods.push(item);
				}
			});
		}
		
		setPgs(uniquePaymentMethods);
		
	}, []);

	// ✅ Auto-select the first payment method
	useEffect(() => {
		if (items.length > 0) {
			setPaymentMethod(items[0]);
		}
	}, [items]);

	// ✅ Auto-select the first promotion
	useEffect(() => {
		if (promotions.length > 0) {
		setSelectedPromotion(promotions[0]);
		}
	}, [promotions]);

	// ✅ Fetch deposit channels when payment method changes
	useEffect(() => {
		console.log("eWa", hasEWallet);
		if (paymentMethod && hasEWallet===false) {
			const fetchPaymentMethodDetails = async () => {
				try {
				const response = await fetch(`${process.env.REACT_APP_API_URL}/api/showpayment-menthod?name=${paymentMethod.name}`, {
					headers: { Authorization: `Bearer ${token}`, 'Origin': window.location.origin },
				});
				const data = await response.json();

					if (data?.success && data.data.length > 0) {
					setPaymentSystems(data.data);
					setSelectedOption(data.data[0]?.id || null); // ✅ Auto-select the first deposit channel
				}
				} catch (error) {
					console.error("Error fetching payment method details:", error);
				} finally {
					setIsLoading(false);
				}
			};
			fetchPaymentMethodDetails();
		}
		if (hasEWallet === true) {
			
			setTimeout(() => {
				let _filtered = [];
				for (let i = 0; i < items.length; i++) {
					// console.log('X',items[i]?.name, paymentMethod?.name);
					if (items[i]?.name.toLowerCase() === paymentMethod?.name.toLowerCase()) {
						_filtered.push(items[i]);
					}
				}
				setPaymentSystems(_filtered);
				setSelectedOption(_filtered[0]?.id || null);
				setIsLoading(false);
			}, 400);
		}
	}, [paymentMethod, token]);


	useEffect(() => { 
		const selectedMethod = items.find((item) => item.id === selectedOption);
		if (selectedMethod?.account_type === 'USDT') {
				setAmountRange([10,200])
				setCurrency('$');
				setPresetAmounts(["10", "20", "30", "50", "100", "150", "200"]);
				setDepositChannel(false);
			} else {
				setAmountRange([200, 25000]);
				setCurrency('৳');
				setPresetAmounts(["200", "500", "1000", "2000", "3000", "5000", "10000", "15000", "20000", "25000"]);
				setDepositChannel(true);
			}
	}, [selectedOption, items]);

	const handleItemClick = (name) => {
		const selectedMethod = items.find((item) => item.name === name);
		if (selectedMethod) {
			setPaymentMethod(selectedMethod);
		}
		setTimeout(() => {
			let _filtered = [];
			for (let i = 0; i < items.length; i++) {
				if (items[i]?.name.toLowerCase() === name.toLowerCase()) {
					_filtered.push(items[i]);
				}
			}
			setPaymentSystems(_filtered);
			setSelectedOption(_filtered[0]?.id || null);
		}, 200);
	};

	const handleSelection = (id) => {
		setSelectedOption(id);
	};

	const handleAmountClick = (amount) => {
		setActiveAmount(amount);
	};

	const handlePromotionChange = (event) => {
		const selectedId = parseInt(event.target.value);
		const selectedPromo = promotions.find((promo) => promo.id === selectedId);
		setSelectedPromotion(selectedPromo || null);
	};

	const handleSubmit = async () => {

		let isVerified = (userData?.session_id=='1') ? true : false;
		if (!isVerified) {
			if (getotherContracts && getotherContracts.length > 0) {
				isVerified = getotherContracts.some(contract => contract.isverify === 1);
			}
			if (!isVerified) {
				setModalMessage(`Please Verfiy Your Phone Profile Settings`);
				setShowModal(true);
				return;
			}
		}

		if (!activeAmount) {
			setModalMessage("Please fill in your amount.");
			setShowModal(true);
			return;
		}

		if (Number(activeAmount) < amountRange[0]) {
			setModalMessage(`Minimum Deposit is ${amountRange[0]} ${currency === '৳' ? 'TK' : currency}. Please try again.`);
			setShowModal(true);
			return;
		}

		if (transactionData && transactionData.length > 0) {
			for (let trns of transactionData) {
				if (trns.action == "deposit" && trns.key === "0") {
					setModalMessage(`You already have a deposit request pending. Please wait for it to be processed before making another deposit.`);
					setShowModal(true);
					return;
				}
			}
		}

		if (!paymentMethod) {
			setModalMessage("Please select a valid payment method.");
			setShowModal(true);
			return;
		}

		const selectedPaymentSystem = paymentSystems.find(item => item.id === selectedOption);
		if (!selectedPaymentSystem) {
			setModalMessage("Please select a Deposit channel.");
			setShowModal(true);
			return;
		}

		setSubmitLoading(true);
		try {
			if (hasEWallet) { 
				try {
					const response = await fetch(`${process.env.REACT_APP_API_URL}/api/ewa/request`, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							'Authorization': `Bearer ${token}`,
							'Origin': window.location.origin,
						},
						body: JSON.stringify({
							amount: activeAmount,
							type: selectedPaymentSystem.account_type,
							provider: paymentMethod.name,
							promotion: selectedPromotion?.id || 0,
						}),
					});
					const data = await response.json();
					
					if (response.ok) {
						if (data?.url) {
							window.location.href = data.url;
							return;
						}
						navigate("/make-payment", {
							state: {
								amount: data?.amount ?? activeAmount,
								payment_icon: selectedPaymentSystem?.icon,
								payment_type: selectedPaymentSystem?.account_type,
								paymentMethodid: paymentMethod?.id,
								paymentMethodName: paymentMethod?.name,
								promotion: selectedPromotion?.id || null,
								transaction: data?.transaction,
								number: data?.number,
								timer: data?.timer ?? 10, 
								message: data?.message
							},
						});
					} else {
						setModalMessage(data?.message || "An error occurred. Please try again.");
						setShowModal(true);
					}
					// } else {
					// }
				} catch (error) { 
					console.error("Error fetching e-wallet request:", error);
					const err = error?.response?.data?.message || "An error occurred. Please try again.";
					setModalMessage(err);
					setShowModal(true);
				}

			} else {
				navigate("/make-payment", {
					state: {
						amount: activeAmount,
						payment_icon: selectedPaymentSystem.icon,
						payment_type: selectedPaymentSystem.account_type,
						paymentMethodid: paymentMethod.id,
						paymentMethodName: paymentMethod.name,
						promotion: selectedPromotion?.id || null,
					},
				});
			}
		} catch (error) {
			setModalMessage("An error occurred. Please try again.");
			setShowModal(true);
		} finally {
			setSubmitLoading(false);
		}
	};

	if (isLoading) {
		return (
		<Splash/>
		);
	}
 return(
    <div className="v-application--wrap">
  <div>
    {/**/}
    <div className="row no-gutters">
      <Header/>
    </div>
    
   
    
    <div className="body">
      <div className>
        <div className="row no-gutters">
        
          <div className="col col-12">
            <div className="px-0" style={{height: '100%'}}>
              <div className="row hidden-md-and-up mobile-header no-gutters">
              <div className="mobile-header-item col col-6 router-link-active selected">
                <Link to="/deposit" className="router-link-exact-active" style={{textDecoration: 'unset !important'}}><span>Deposit</span></Link>
              </div>
              <div  className="text-center mobile-header-item col col-6 ">
                <Link to="/withdrawal" className style={{textDecoration: 'unset !important'}}><span>Withdrawal</span></Link>
              </div>
            </div>
              <div className="desktop_depo_card v-card v-sheet theme--light">
                {/**/}
                <div className="v-card__title hidden-sm-and-down pl-3 ml-7"><label className="--v-primary-base depo-desktop-txt text-left text-capitalize">Deposit</label></div>
                <div className="bank-detail-card deposit-card v-card v-sheet theme--light elevation-0">
                  <div>
                    <div className="row breakpoint no-gutters align-end px-8 pt-4">
                      <div className="col col-auto">
                        <div className="hidden-md-and-up">
                          <label className="input-field-label ma-0 text-capitalize d-block pb-1">
                            Payment Methods
                          </label>
                        </div>
                        <div className="hidden-sm-and-down">
                          <label className="input-field-label ma-0 text-capitalize d-block pb-1">
                            Deposit Options
                          </label>
                        </div>
                        <div className="row py-2 mb-3 no-gutters" style={{gap: '0.5rem'}}>
                          {pgs.map((item) =>
                            item.status === "active" && (
                              <div className="col col-auto" key={item.name}>
                                <button
                                  type="button"
                                  onClick={() => handleItemClick(item.name)}
                                  className={`v-btn active-gateway-button ${
                                    paymentMethod?.name === item.name ? "v-btn--active" : ""
                                  } v-btn--outlined theme--light v-size--default pa-2 gateway-button mobile-paymentMethod`}
                                  style={{ height: "100%", width: "100px" }}
                                >
                                  <span className="v-btn__content">
                                    <img
                                      src={`${item.icon}`}
                                      alt={item.name}
                                    />
                                  </span>
                                </button>
                              </div>
                            )
                          )}

                        </div>
                      </div>
                    </div>
                    {/**/}{/**/}
                    <form noValidate="novalidate" className="v-form">
                      <div className="row pb-2 breakpoint no-gutters align-end px-8 pt-4">
                        <div className="col-md-12 col">
                          <label className="input-field-label ma-0 text-capitalize d-block pb-2">
                            Deposit Channel
                          </label>
                          <div className="row py-2 pb-2 no-gutters">
                            {paymentSystems.map((ps) => (
                              <div className="mr-2 col col-auto" key={ps.id}>
                                <button
                                  type="button"
                                  onClick={() => {
                                    handleSelection(ps.id);
                                    setActiveItem(ps.id);
                                  }}
                                  className={`pa-2 theme-button font-weight-bold deposit-channel v-btn v-btn--outlined theme--light v-size--default ${
                                    selectedOption === ps.id ? "active-deposit-channel v-btn--active" : ""
                                  }`}
                                  style={{ height: "auto" }}
                                >
                                  <span className="v-btn__content">
                                    <label className="gateway_name">
                                      {/* Show name or account type conditionally */}
                                      {ps.account_type === "Agent" && "Cashout"}
                                      {(ps.account_type === "Merchant" || ps.account_type === "Marchent") && "Merchant"}
                                      {ps.account_type === "Personal" && "Send Money"}
                                    </label>

                                    {ps.percent && (
                                      <span
                                        className="percent-label-2 ma-0 v-chip v-chip--label theme--light v-size--x-small mobile-depo-percent pa-1"
                                        style={{
                                          backgroundColor: "rgb(79, 14, 204)",
                                          borderColor: "rgb(79, 14, 204)",
                                          right: "-18px",
                                          top: "-15px",
                                          position: "relative",
                                        }}
                                      >
                                        
                                      </span>
                                    )}
                                  </span>
                                </button>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                     
                      <div className="row breakpoint no-gutters align-end px-8">
                        <div className="col-md-6 col">
                          <div className="depo-box mobile" light remark="fieldHint.promotionRemark">
                            <div className="row no-gutters justify-space-between">
                              <div className="col col-10">
                                <label className="input-field-label ma-0 text-capitalize d-block pb-1" style={{float: 'left'}}> Deposit Bonus<span className="red--text ml-1">*</span></label>
                              </div>
                              <div className="col col-2">{/**/}</div>
                              <div className="col col-12">

                               
                                <div className="v-input input-field v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-select">
                                  <select
                                onChange={handlePromotionChange}
                                value={selectedPromotion?.id || ""}
                                className="v-input v-text-field v-select pa-2"
                                style={{
                                  width: "100%",
                                  borderRadius: "8px",
                                  padding: "8px 12px",
                                  border: "1px solid #ccc",
                                  background: "#fff",
                                  marginBottom: '10px'
                                }}
                              >
                                <option value={null}>No Bouns Selected</option>
                                {promotions.map((promotion) => (
                                  <option key={promotion.id} value={promotion.id}>
                                    {promotion.name}{" "}
                                    {promotion.percent ? `- ${promotion.percent}%` : ""}
                                  </option>
                                ))}
                              </select>

     
      
    
                                </div>


                               
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row breakpoint no-gutters align-end px-8 pt-4">
                        <div className="col-md-6 col">
                          <div className="mobile">
                            <div className="row no-gutters justify-space-between">
                              <div className="col col-10">
                                <label className="input-field-label ma-0 text-capitalize d-block pb-1" style={{float: 'left'}}> Deposit amount<span className="red--text ml-1">*</span></label>
                              </div>
                              <div className="col col-2">
                                <i aria-hidden="true" aria-haspopup="true" aria-expanded="false" className="v-icon notranslate material-icons theme--dark primary--text" style={{float: 'right'}}>help</i>
                                <span className="v-tooltip v-tooltip--right">{/**/}</span>
                              </div>
                              <div className="col col-12">
                                <div className="v-input input-field elevation-0 hide-details v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder">
                                  <div className="v-input__control">
                                    <div className="v-input__slot">
                                      <fieldset aria-hidden="true">
                                        <legend style={{width: '0px'}}><span className="notranslate">​</span></legend>
                                      </fieldset>
                                      <div className="v-text-field__slot">
                                       <input
                                        type="number"
                                        name="amount"
                                        placeholder="Min Deposit 200 TK"
                                       
                                        value={activeAmount}
                                        onChange={(e) => setActiveAmount(e.target.value)} 
                                        onClick={(e) => e.stopPropagation()} 
                                      />
                                       </div>
                                    </div>
                                    <div className="v-text-field__details">
                                      <div className="v-messages theme--light"><div className="v-messages__wrapper" /></div>
                                    </div>
                                  </div>
                                </div>
                                {/**/}{/**/}
                              </div>
                            </div>
                          </div>
                          {/**/}
                        </div>
                      </div>
                      <div className="row pb-2 breakpoint no-gutters align-end px-8 pt-4">
                        <div className="col">
                          <div className="row no-gutters">
                           {presetAmounts.map((amount) => (
                              <div className="pr-2 pb-2 hidden-md-and-up col col-4" key={amount}>
                                <button
                                  type="button"
                                  onClick={() => handleAmountClick(amount)}
                                  className={`pa-2 full-width theme-button font-weight-bold hidden-md-and-up mobile-amount-button v-btn v-btn--has-bg theme--light v-size--default ${
                                    activeAmount === amount ? "active-amount-button v-btn--active" : ""
                                  }`}
                                  style={{ height: "auto" }}
                                >
                                  <span className="v-btn__content">
                                    <span
                                      className="percent-label-2 ma-0 pa-1 v-chip v-chip--label v-chip--no-color theme--light v-size--x-small"
                                      style={{
                                        color: "#fff",
                                        backgroundColor: "rgb(79, 14, 204)",
                                      }}
                                    >
                                      <span className="v-chip__content">
                                        +{selectedPromotion?.deposit_bouns ? Math.round(selectedPromotion.deposit_bouns) : 0}%
                                      </span>
                                    </span>
                                    {amount}
                                  </span>
                                </button>
                              </div>
                            ))}

                          
                         
                          
                            
                         
                         
                           
                          </div>
                        </div>
                      </div>
                      {/**/}
                      
                    </form>
                    <div className="row pb-5 breakpoint no-gutters align-end px-8">
                      <div className="col-md-6 col">
                        <button onClick={handleSubmit} type="button" className="theme-button depo-width black--text v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default deposit-btn buttonPrimary">
                          <span className="v-btn__content">
                            Deposit
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {showModal && (
                 <div role="document" tabIndex={0} data-v-c5353408 className="v-dialog__content v-dialog__content--active" style={{zIndex: 202}}>
                <div className="v-overlay v-overlay--active theme--dark" style={{zIndex: 201}}>
              <div className="v-overlay__scrim" style={{opacity: '0.46', backgroundColor: 'rgb(33, 33, 33)', borderColor: 'rgb(33, 33, 33)'}} />
              <div className="v-overlay__content" />
            </div>

                <div className="v-dialog v-dialog--active v-dialog--persistent" style={{transformOrigin: 'center center', maxWidth: '400px'}}>
                  <div data-v-c5353408 className="dialog-card v-card v-sheet theme--dark">
                    <div data-v-c5353408 className="row no-gutters justify-space-between dialog-header pt-3 px-3">
                      <div data-v-c5353408 className="col col-11">
                        <label data-v-c5353408 className="dialog-title pt-3 ma-0 text-capitalize d-block full-width"> Deposit Details</label>
                        {/**/}
                      </div>
                      <div data-v-c5353408 className="col col-1"><button onClick={() => setShowModal(false)} data-v-c5353408 type="button" className="v-icon notranslate v-icon--link mdi mdi-close theme--dark dialog-close-icon" /></div>
                      {/**/}
                    </div>
                    <div data-v-c5353408 className="row no-gutters px-3 py-3">
                      <div data-v-c5353408 className="col col-12"><hr data-v-c5353408 role="separator" aria-orientation="horizontal" className="dialog-divider v-divider theme--dark" /></div>
                    </div>
                    <div data-v-c5353408 className="row d-block dialog-row no-gutters pa-3 pt-0">
                     {modalMessage}
                    </div>
                  </div>
                </div>
              </div>

              ) }
             

            </div>
          </div>
        </div>
        {/**/}
      </div>
      {/**/}
    </div>
   <Toolbar/>
    <Chat/>
  </div>
</div>

 );
}
export default Deposit;